import React from 'react';
import {
  PreferredPlaceOption,
  preferredPlaceOfCareOptions,
  preferredPlaceOfDeathOptions,
} from './commons';

type PreferredPlacesField =
  | 'preferredPlaceOfCareFirstChoice'
  | 'preferredPlaceOfCareSecondChoice'
  | 'preferredPlaceOfDeathFirstChoice'
  | 'preferredPlaceOfDeathSecondChoice';

interface PreferredPlacesSectionProps {
  preferredPlaceOfCareFirstChoice: string;
  preferredPlaceOfCareSecondChoice: string;
  preferredPlaceOfDeathFirstChoice: string;
  preferredPlaceOfDeathSecondChoice: string;
  updateEndOfLifeCare: (field: PreferredPlacesField, value: string) => void;
}

interface PreferredPlaceSelectProps {
  id: string;
  label: string;
  name: string;
  value: string;
  field: PreferredPlacesField;
  options: PreferredPlaceOption[];
  updateEndOfLifeCare: (field: PreferredPlacesField, value: string) => void;
}

const PreferredPlaceSelect: React.FC<PreferredPlaceSelectProps> = ({
  id,
  label,
  name,
  value,
  field,
  options,
  updateEndOfLifeCare,
}) => {
  return (
    <div className="govuk-form-group">
      <label className="govuk-label govuk-label--m" htmlFor={id}>
        {label}
      </label>

      <select
        className="govuk-select govuk-!-width-full"
        id={id}
        name={name}
        value={value}
        onChange={e => updateEndOfLifeCare(field, e.target.value)}
      >
        {options.map(option => (
          <option key={option.value || 'select'} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

const PreferredPlacesSection: React.FC<PreferredPlacesSectionProps> = ({
  preferredPlaceOfCareFirstChoice,
  preferredPlaceOfCareSecondChoice,
  preferredPlaceOfDeathFirstChoice,
  preferredPlaceOfDeathSecondChoice,
  updateEndOfLifeCare,
}) => {
  return (
    <div className="mt-10 govuk-bp:mt-14">
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-one-half">
          <PreferredPlaceSelect
            id="preferred-place-of-care-first-choice"
            name="preferredPlaceOfCareFirstChoice"
            label="Preferred Place of Care (1st Choice)"
            value={preferredPlaceOfCareFirstChoice}
            field="preferredPlaceOfCareFirstChoice"
            options={preferredPlaceOfCareOptions}
            updateEndOfLifeCare={updateEndOfLifeCare}
          />
        </div>

        <div className="govuk-grid-column-one-half">
          <PreferredPlaceSelect
            id="preferred-place-of-care-second-choice"
            name="preferredPlaceOfCareSecondChoice"
            label="Preferred Place of Care (2nd Choice)"
            value={preferredPlaceOfCareSecondChoice}
            field="preferredPlaceOfCareSecondChoice"
            options={preferredPlaceOfCareOptions}
            updateEndOfLifeCare={updateEndOfLifeCare}
          />
        </div>
      </div>

      <div className="govuk-grid-row mt-8">
        <div className="govuk-grid-column-one-half">
          <PreferredPlaceSelect
            id="preferred-place-of-death-first-choice"
            name="preferredPlaceOfDeathFirstChoice"
            label="Preferred Place of Death (1st Choice)"
            value={preferredPlaceOfDeathFirstChoice}
            field="preferredPlaceOfDeathFirstChoice"
            options={preferredPlaceOfDeathOptions}
            updateEndOfLifeCare={updateEndOfLifeCare}
          />
        </div>

        <div className="govuk-grid-column-one-half">
          <PreferredPlaceSelect
            id="preferred-place-of-death-second-choice"
            name="preferredPlaceOfDeathSecondChoice"
            label="Preferred Place of Death (2nd Choice)"
            value={preferredPlaceOfDeathSecondChoice}
            field="preferredPlaceOfDeathSecondChoice"
            options={preferredPlaceOfDeathOptions}
            updateEndOfLifeCare={updateEndOfLifeCare}
          />
        </div>
      </div>
    </div>
  );
};

export default PreferredPlacesSection;
